module.exports = __webpack_public_path__ + "static/media/998180.6a7887fe.png";